<template>
  <div>
    <template v-if="crud_fee_company === true">
      <div class="page-top mb-1 mb-3 clearfix">
        <div class="global-main">
          <form id="collectionFeeForm" @submit.prevent="addCollectionCompanyData">
            <div class="px-5 mx-5">
              <div class="row">
                <div class="form-group col-3">
                  <h3 class="mt-3 mb-4"> Collection </h3>
                </div>
                <div class="form-group col-3">
                  <div class="swither">
                    <label class="swither-inner" for="collection_status">
                      <span class="swither-label"> Off </span>
                      <input v-model="form.collection_status"  id="collection_status" type="checkbox" checked="" />
                      <label class="label-for-input" for="collection_status"> </label>
                      <span class="swither-label"> On </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="">
                  <div class="form-group">
                    <label>Company <em class="required">*</em></label>
                    <input readonly class="form-control" v-bind:value="company.name" />
                    <input type="hidden" name="company_id" v-model="form.company_id" readonly v-bind:value="form.company_id"
                    <has-error :form="form" field="company_id"></has-error>
                  </div>
                <div class="form-group">
                  <label> Email <em class="required">*</em></label>
                  <input class="form-control" readonly v-bind:value="company.email">
                </div>
                <div class="form-group">
                  <label> Phone <em class="required">*</em></label>
                  <input class="form-control" readonly v-bind:value="company.phone">
                </div>
                <div class="form-group">
                  <label> Virtual Account Number <em class="required">*</em></label>
                  <input class="form-control" readonly v-bind:value="company.walletID">
                </div>
                <div class="col-md-12 text-left">
                  <div class="row align-items-center">
                    <div class="col-2"><label for="" class="label block-label">Creation Type</label></div>
                    <div class="col-2">
                      <label class="radio-holder">
                        Internal
                        <input v-model="form.collection_type" value="internal" type="radio" name="creation-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div class="col-2">
                      <label class="radio-holder">
                        External
                        <input v-model="form.collection_type" value="external" type="radio" name="creation-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-show="form.collection_type == 'external'">
                <div class="col-md-12">
                  <div class="form-group">
                    <label> APP BASE URL <em class="required">*</em></label>
                    <input type="text" name="base_url" v-model="form.base_url" class="form-control" :class="{ 'is-invalid': form.errors.has('base_url') }" placeholder="http://finjabusiness.test" />
                    <has-error :form="form" field="base_url"></has-error>
                  </div>
                  <div class="form-group">
                    <label> APP ID <em class="required">*</em></label>
                    <input type="text" name="app_id" v-model="form.app_id" class="form-control" :class="{ 'is-invalid': form.errors.has('app_id') }" placeholder="APP ID" />
                    <has-error :form="form" field="app_id"></has-error>
                  </div>
                  <div class="form-group">
                    <label> APP KEY <em class="required">*</em></label>
                    <input type="text" name="app_key" v-model="form.app_key" class="form-control" :class="{ 'is-invalid': form.errors.has('app_key') }" placeholder="APP KEY" />
                    <has-error :form="form" field="app_key"></has-error>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="collection-box">
                    <div class="box-head">
                      <span class="title"> Creation </span>
                      <div class="swither">
                        <label class="swither-inner" for="creation_fee_status">
                          <span class="swither-label"> Off </span>
                          <input v-model="form.creation_fee_status"  id="creation_fee_status" type="checkbox" checked="" />
                          <label class="label-for-input" for="creation_fee_status"> </label>
                          <span class="swither-label"> On </span>
                        </label>
                      </div>
                    </div>
                    <div class="box-inner-content">
                      <span class="title"> Creation Charges </span>
                      <label class="radio-holder">
                        Fix
                        <input type="radio" v-model="form.creation_charges_type" value="fixed" name="creation-charges-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                      <label class="radio-holder">
                        Percentage
                        <input type="radio" v-model="form.creation_charges_type" value="percentage" name="creation-charges-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                      <span class="title"> FED </span>
                      <label class="radio-holder">
                        Inclusive
                        <input type="radio" v-model="form.creation_fed_type" value="inclusive" name="creation-fed-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                      <label class="radio-holder">
                        Exclusive
                        <input type="radio" v-model="form.creation_fed_type" value="exclusive" name="creation-fed-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                      <div class="form-group mt-3">
                        <span class="title"> Collection Creation Charges <strong v-if="form.creation_charges_type == 'percentage'">(%)</strong> <strong v-if="form.creation_charges_type == 'fixed'">(Rs.)</strong></span>
                        <input type="number" min="0" step=".01" v-model="form.creation_charges" class="form-control" placeholder="Creation Charges" />
                      </div>
                      <div class="form-group" v-if="form.creation_charges_type == 'percentage'">
                        <span class="title"> Max Creation Charges <strong>(Rs.)</strong> </span>
                        <input type="number" min="0" step=".01" v-model="form.max_creation_charges" class="form-control" placeholder="Max Creation Charges" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="collection-box">
                    <div class="box-head">
                      <span class="title"> Consumption </span>
                      <div class="swither">
                        <label class="swither-inner" for="consumption_fee_status">
                          <span class="swither-label"> Off </span>
                          <input v-model="form.consumption_fee_status" id="consumption_fee_status" type="checkbox" checked="" />
                          <label class="label-for-input" for="consumption_fee_status"> </label>
                          <span class="swither-label"> On </span>
                        </label>
                      </div>
                    </div>
                    <div class="box-inner-content">
                      <span class="title"> Consumption Charges </span>
                      <label class="radio-holder">
                        Fix
                        <input type="radio" v-model="form.consumption_charges_type" value="fixed" name="consumption-charges-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                      <label class="radio-holder">
                        Percentage
                        <input type="radio" v-model="form.consumption_charges_type" value="percentage" name="consumption-charges-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                      <span class="title"> FED </span>
                      <label class="radio-holder">
                        Inclusive
                        <input type="radio" v-model="form.consumption_fed_type" value="inclusive" name="consumption-fed-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                      <label class="radio-holder">
                        Exclusive
                        <input type="radio" v-model="form.consumption_fed_type" value="exclusive" name="consumption-fed-type" checked="">
                        <span class="checkmark"></span>
                      </label>
                      <div class="form-group mt-3">
                        <span class="title"> Collection Consumption Charges <strong v-if="form.consumption_charges_type == 'percentage'">(%)</strong> <strong v-if="form.consumption_charges_type == 'fixed'">(Rs.)</strong> </span>
                        <input type="number" min="0" step=".01" v-model="form.consumption_charges" class="form-control" placeholder="Consumption Charges" required/>
                      </div>
                      <div class="form-group" v-if="form.consumption_charges_type == 'percentage'">
                        <span class="title"> Max Consumption Charges <strong>(Rs.)</strong> </span>
                        <input type="number" min="0" step=".01" v-model="form.max_consumption_charges" class="form-control" placeholder="Max Consumption Charges" required required />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-right mt-5">
                  <router-link to="/feeCompanies" class="btn btn-primary mr-1">Cancel</router-link>
                  <button :disabled="form.busy" class="btn btn-primary  active">Submit</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </template>
    <template v-else-if="crud_fee_company === null">
      <preLoader></preLoader>
    </template>
    <template v-else-if="crud_fee_company === false">
      <notAllowed></notAllowed>
    </template>
  </div>
</template>
<script>
    export default {
        data() {
            return {
              form : new Form({
                company_id : '',
                collection_status : '',
                creation_fee_status : '',
                consumption_fee_status : '',
                creation_charges_type : 'percentage',
                consumption_charges_type : 'percentage',
                creation_fed_type : 'exclusive',
                consumption_fed_type : 'exclusive',
                creation_charges : '',
                consumption_charges : '',
                max_creation_charges : '',
                max_consumption_charges : '',
                collection_type : 'internal',
                app_id : null,
                app_key : null,
                base_url : null,
              }),
                company : {
                    name : '',
                    email : '',
                    phone : '',
                    walletID : ''
                },
                crud_fee_company : null,
            }
        },
        methods: {
            addCollectionCompanyData() {
                this.$Progress.start();
                this.form.post('/api/addCollectionCompany')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Company record has been updated');
                        this.$router.push('/feeCompanies');
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
            getAddCollectionCompanyData(){
                this.$Progress.start();
                var that = this;
                axios.get('/api/editCollectionCompanyData/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        that.form.company_id = res.data.company.id;
                      if(res.data.company.collection == 'ON'){that.form.collection_status = true;}else{that.form.collection_status = false;}
                        that.form.collection_type = res.data.collectionFee.collection_type;
                      if(res.data.collectionFee.creation_fee_status == 'ON'){that.form.creation_fee_status = true;}else{that.form.creation_fee_status = false;}
                      if(res.data.collectionFee.consumption_fee_status == 'ON'){that.form.consumption_fee_status = true;}else{that.form.consumption_fee_status = false;}
                        that.form.creation_charges_type = res.data.collectionFee.creation_fee_type;
                        that.form.consumption_charges_type = res.data.collectionFee.consumption_fee_type;
                        that.form.creation_fed_type = res.data.collectionFee.creation_fed;
                        that.form.consumption_fed_type = res.data.collectionFee.consumption_fed;
                        that.form.creation_charges = res.data.collectionFee.creation_fee;
                        that.form.consumption_charges = res.data.collectionFee.consumption_fee;
                        that.form.max_creation_charges = res.data.collectionFee.max_creation_fee;
                        that.form.max_consumption_charges = res.data.collectionFee.max_consumption_fee;
                        that.form.app_id = res.data.externalCollectionConfig.app_id;
                        that.form.app_key = res.data.externalCollectionConfig.app_key;
                        that.form.base_url = res.data.externalCollectionConfig.base_url;

                        that.company.name = res.data.company.name;
                        that.company.email = res.data.company.email;
                        that.company.phone = res.data.company.phone;
                        that.company.walletID = res.data.company.walletID;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
        },
        mounted() {
            this.$Progress.start();
            var that = this;
            this.can('crud_fee_company').then(result => {
                this.crud_fee_company = result.crud_fee_company;
            }).then(result => {
                if(this.crud_fee_company == true){
					this.getAddCollectionCompanyData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
            window.changeParams = function(obj){
                that.company.email = $(obj).children("option:selected").attr('data-email');
                that.company.phone = $(obj).children("option:selected").attr('data-phone');
                that.company.walletID = $(obj).children("option:selected").attr('data-walletID');
            }
        },
    }
</script>
